export const renderLinks = (
	docsDropdown,
	handleDocsDropdown,
	serviceList,
	settingsMenu
) => [
	/**
	 * A function that expects:
	 * docsDropdown - variable to show or hide documents submenus,
	 * handleDocsDropdown - click handler which update the docsDropdown variable,
	 * serviceList - array with all services which need to be rendered,
	 * settingsMenu - variable that holds the value when the settings menu should be activated or not.
	 *
	 * The function return an array so all elements in the sidebar can be rendered properly on the screen.
	 */
	// {
	//   path: "/start",
	//   iconBefore: "fa fa-home",
	//   title: "Startseite"
	// },
	// {
	//   path: "/services",
	//   iconBefore: "fa fa-tasks",
	//   title: "Services"
	// },
	{
		path: '/documents',
		iconBefore: docsDropdown ? 'far fa-folder-open' : 'fas fa-folder',
		title: 'Dokumente',
		iconAfter: 'fas fa-ellipsis-h ml-5',
		tag: 'span',
		class: 'pointer pr-0',
		clickHandler: handleDocsDropdown,
		children: serviceList,
	},
	{
		path: '/settings/0',
		iconBefore: 'fa fa-cogs',
		title: 'Einstellungen',
		active: settingsMenu,
		adminCheck: true,
	},
	// {
	//   path: "/support",
	//   iconBefore: "fa fa-bug",
	//   title: "Support"
	// }
];

export const iconList = {
	/**
	 * Object that collects all key:value pairs for all the services icons.
	 */
	detect_types: 'fas fa-copy',
	extract_data: 'fas fa-share-square',
	signature_docs: 'fas fa-file',
	signature_envelopes: 'fas fa-folder',
	compare_documents: 'fas fa-copy',
	no_roles: 'far fa-times-circle text-danger',
	docs_split: 'fas fa-file',
};
